import gql from 'graphql-tag';

export const GET_CLASSES = gql`
  query GetClasses($query: ClassQuery!) {
    getClasses(query: $query) {
      _id
      name
    }
  }
`;
